/** Shared with the shipped mobile composer and the existing Django endpoints. */
export interface AuthoredAttachments {
  context?: { body: string; sources: { url: string; label: string }[] };
  cherishPrompt?: string;
  mood?: { label: string; emoji: string };
}
export interface Selection {
  slug: string;
  revision: number;
}
export interface CollaborationSelection extends Selection {
  version: number;
  body: string;
  title: string;
}
export interface Ring {
  id: string;
  revision: number;
  name: string;
  people: { handle: string; name?: string }[];
}
export interface Viewpoint {
  id: string;
  label?: string;
  text?: string;
  authorship?: string;
  author?: { name: string; handle: string };
  unavailable?: boolean;
  consent?: string;
}
export interface Perspectives {
  slug: string;
  title: string;
  commonGround: string;
  viewpoints: Viewpoint[];
}
export interface StudioResource {
  slug: string;
  title: string;
  revision: number;
  role: string;
  owner: { id: string; handle: string };
  data: {
    state: string;
    body?: string;
    commonGround?: string;
    viewpoints?: Viewpoint[];
    contributors?: Participant[];
    collaborators?: Participant[];
  };
}
export interface Participant {
  person: { id: string; handle: string };
  state: string;
}
export interface ComposerExtras {
  attachments: AuthoredAttachments;
  question: boolean;
  ring?: Ring;
  perspective?: StudioResource;
  collaboration?: CollaborationSelection;
}
export const emptyExtras = (): ComposerExtras => ({ attachments: {}, question: false });
export function extrasPayload(extras: ComposerExtras, continuingThread: boolean) {
  return {
    ...(Object.keys(extras.attachments).length ? { attachments: extras.attachments } : {}),
    ...(extras.question ? { question: true } : {}),
    ...(extras.ring && !continuingThread
      ? { audienceRing: { id: extras.ring.id, revision: extras.ring.revision } }
      : {}),
    ...(extras.perspective
      ? {
          perspectiveSplit: {
            slug: extras.perspective.slug,
            revision: extras.perspective.revision,
          },
        }
      : {}),
    ...(extras.collaboration
      ? {
          collaborativeDraft: {
            slug: extras.collaboration.slug,
            revision: extras.collaboration.revision,
            version: extras.collaboration.version,
          },
        }
      : {}),
  };
}
